import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MessagesService } from './messages.service';

@Component({
	selector: 'lib-messages-outlet',
	templateUrl: './messages-outlet.component.html',
	styleUrl: './messages-outlet.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesOutletComponent {
	readonly messagesSrv = inject(MessagesService);
}
